import { render, staticRenderFns } from "./checkgaranzia.vue?vue&type=template&id=252604ac"
import script from "./checkgaranzia.vue?vue&type=script&lang=js"
export * from "./checkgaranzia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('252604ac')) {
      api.createRecord('252604ac', component.options)
    } else {
      api.reload('252604ac', component.options)
    }
    module.hot.accept("./checkgaranzia.vue?vue&type=template&id=252604ac", function () {
      api.rerender('252604ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/checkgaranzia.vue"
export default component.exports